export default __webpack_public_path__ + "static/media/service_planning.ab72a038.png";